export default __webpack_public_path__ + "static/media/EXPRESS.cbce1343.jpg";